import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.less';

const RelatedLinks = (props) => {
    return (
        <div className="p-related-links" data-content-id={props.contentId}>
            {props.title ? (
                <div className="p-related-links__title">
                    <a href={props.titleUrl}>{props.title}</a>
                </div>
            ) : null}
            <ul className="p-related-links__list">
                {props.items.map((item, i) => {
                    const key = i;

                    const attribs = {
                        className: classNames({
                            'p-related-links_item': true,
                            'u-app-hide': item.isHiddenInApp
                        }),
                        'data-pb-appears': item.appears,
                        'data-pb-expires': item.expires
                    };

                    const innerAttribs = {
                        className: 'p-related-links__link',
                        href: item.url,
                        target: item.openInNewTab ? '_blank' : undefined,
                        'data-phone-href': item.mobileUrl || undefined
                    };

                    return (
                        <li {...attribs} key={key}>
                            <a {...innerAttribs} data-cid={item.contentId}>
                                {item.title}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

RelatedLinks.propTypes = {
    title: PropTypes.string,
    contentId: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            state: PropTypes.string,
            contentId: PropTypes.string,
            openInNewTab: PropTypes.bool,
            url: PropTypes.string.isRequired,
            mobileUrl: PropTypes.string
        })
    ).isRequired,
    titleUrl: PropTypes.string
};

RelatedLinks.defaultProps = {
    title: undefined,
    contentId: undefined,
    titleUrl: '?'
};

export default RelatedLinks;
